import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "d4ps_access_token";
const PREAUTH_KEY = "d4ps_preauth_token";

export const tokenStorage = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export const preauthStorage = {
  get: () => sessionStorage.getItem(PREAUTH_KEY),
  set: (t) => sessionStorage.setItem(PREAUTH_KEY, t),
  clear: () => sessionStorage.removeItem(PREAUTH_KEY),
};

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = tokenStorage.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export function gbp(value) {
  const n = Number(value || 0);
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);
}

export function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = iso.length <= 10 ? new Date(iso + "T00:00:00") : new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fileUrl(url) {
  const token = tokenStorage.get();
  const sep = url.includes("?") ? "&" : "?";
  return `${API_BASE}${url}${token ? `${sep}token=${encodeURIComponent(token)}` : ""}`;
}

export async function downloadPdf(url, filename) {
  // Download without opening a new tab. Since our backend sends
  // `Content-Disposition: attachment` on every PDF endpoint, a plain anchor
  // click triggers the download and the current page stays put.
  const fullUrl = fileUrl(url);
  const link = document.createElement("a");
  link.href = fullUrl;
  link.rel = "noopener";
  if (filename) link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
}
